import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"

import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

import { IProject, ITheme } from "../../../types/project"
import PopinProject from "./PopinProjet"
import { IFilter } from "../../../types/type"
import { ViewCard, ViewList } from "./ProjectViews"
import { useRenderOn } from "../../../hooks/useRenderOn"
import styled from "styled-components"

const StyledRow = styled(Row)`
  /* padding-bottom: 60px; */
`

const ThemeTitle = styled.div`
  font-size: var(--font-size-xl);
  margin-bottom: 20px;
`
const Theme = styled(Col)`
  &:after {
    content: "";
    display: block;
    border-bottom: 1px solid var(--color-grey-3);
    margin-bottom: 20px;
  }
`

const popinTransition = 600

interface IProps {
  list: IProject[]
  defaultView: boolean
  selectedFilter: string | null
  filters?: IFilter[]
  themes?: ITheme[]
}

const ThumbsProject = ({
  list,
  defaultView,
  selectedFilter,
  filters,
  themes,
}: IProps): JSX.Element => {
  const { xs } = useRenderOn()

  /**
   * Select popin wrapper
   */
  const [target, setTarget] = useState<Element | null>()

  useEffect(() => {
    setTarget(document.querySelector("#popinWrapper"))
  }, [])

  /**
   * Selected & open project
   */
  const [selectedProject, setSelectedProject] = useState<IProject>()
  const [popinOpen, setPopinOpen] = useState<boolean>(false)

  const selectProject = (item: IProject): void => {
    setPopinOpen(true)
    setSelectedProject(item)

    // Reset scrollTop when a popin is open
    const popinColumn = document.querySelector("#popin-column")

    if (popinColumn) {
      popinColumn.scrollTop = 0
    }
  }

  const closePopin = () => {
    setPopinOpen(false)

    setTimeout(() => {
      setSelectedProject(undefined)
    }, popinTransition)
  }

  /**
   * Filter cardView projects
   */
  const filteredCardViewProjects = (item: IProject) => {
    // only cardView
    if (item.cardView) {
      // if no selected filter
      if (selectedFilter === null) {
        return true
      }

      // if a filter is selected
      if (
        selectedFilter &&
        item.role &&
        item.role.indexOf(selectedFilter) >= 0
      ) {
        return true
      }
    }
  }

  const projectByTheme = (theme: string) => (
    <>
      {list
        .filter(filteredCardViewProjects)
        .filter(item => item.theme?.includes(theme))
        .map((item, i) => {
          const isFocus: boolean =
            !!item.focus && !!item?.cover?.fluid

          return (
            <ViewCard
              key={i}
              item={item}
              isFocus={isFocus}
              selectProject={selectProject}
              selectedProject={selectedProject}
              popinOpen={popinOpen}
            />
          )
        })}
    </>
  )

  return (
    <StyledRow>
      {defaultView ? (
        <>
          {themes?.map(
            ({ label, text }, i: number) =>
              projectByTheme(label).props.children.length > 0 && (
                <Theme xl={12} key={i}>
                  <ThemeTitle>{text}</ThemeTitle>
                  <Row>{projectByTheme(label)}</Row>
                </Theme>
              )
          )}
        </>
      ) : filters ? (
        filters.map(({ name, results }, i) => {
          return (
            <ViewList
              key={i}
              name={name}
              results={results}
              list={list}
              selectProject={selectProject}
              selectedProject={selectedProject}
              popinOpen={popinOpen}
            />
          )
        })
      ) : null}

      {target &&
        createPortal(
          <PopinProject
            project={selectedProject}
            closePopin={closePopin}
            active={popinOpen}
            popinTransition={popinTransition}
            xs={xs}
          />,
          target
        )}
    </StyledRow>
  )
}

export default ThumbsProject
